import React from "react";

export interface ComplianceItem {
  code: string;
  description: string;
}

interface ComplianceSectionProps {
  items: ComplianceItem[];
}

export const ComplianceSection: React.FC<ComplianceSectionProps> = ({
  items,
}) => {
  return (
    <div className="flex flex-col lg:flex-row gap-8">
      {/* ZED Certificate */}
      <div className="lg:w-[40%] flex justify-center items-center">
        <img src="/assets/images/zed-certificate.webp" alt="ZED Certificate" className="rounded-xl h-[85%]"/>
      </div>

      {/* Compliance List */}
      <div className="lg:w-[60%] flex flex-col justify-center">
        <div className="">
          <span className="block text-xs font-bold text-gray-400 uppercase tracking-[0.15em] pb-4">
            Certification And Accreditation
          </span>
          <h2 className="text-3xl md:text-4xl font-medium text-slate-900 pb-2 bg-gradient-to-r
            from-[#e20016] from-[0%]
            via-[#712f59] via-[40%]
            to-[#005d9c] to-[100%] bg-clip-text text-transparent">
            Certifications & Quality Compliance
          </h2>
          <p className="text-gray-500 leading-relaxed text-sm md:text-base">
            Croma Ply products are manufactured in compliance with BIS
            specifications and recognised quality standards, ensuring consistent
            performance, safety, and responsible manufacturing across all product
            categories.
          </p>
        </div>

        <div className="space-y-4 pt-4">
          {items.map((item, index) => (
            <div
              key={index}
              className={`flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-1 text-sm md:text-[15px] leading-relaxed text-gray-600 ${
                index !== items.length - 1 ? "border-b border-gray-100" : ""
              }`}
            >
              <span className="font-medium text-slate-700 mr-1 break-words">
                {item.code}: {item.description}
              </span>
              
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

